import {closestCenter, DndContext, DragOverlay, useDraggable, useDroppable} from "@dnd-kit/core";
import {
    Collapse,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    Paper,
    TextField,
    Tooltip,
    Typography
} from "@mui/material";
import React, {useEffect, useState} from "react";
import {Check, DragIndicator, ExpandLess, ExpandMore, Search, SyncAlt} from "@mui/icons-material";
import {assignTodosToKpis, getAllTodos, getKpis} from "../../../API/clientRetention";
import {toast} from "react-toastify";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import Box from "@mui/material/Box";
import {LoadingButton} from "@mui/lab";

function DraggableItem({id, children}) {
    const {attributes, listeners, setNodeRef, transform, isDragging} = useDraggable({ id });

    const style = {
        transform: `translate3d(${transform?.x ?? 0}px, ${transform?.y ?? 0}px, 0)`,
    };

    return typeof children === 'function'
        ? children({
            ref: setNodeRef,
            attributes,
            listeners,
            isDragging,
            style
        })
        : null;
}

// Droppable Area Component
function DroppableArea({id, children}) {
    const {setNodeRef} = useDroppable({
        id,
    });

    return (
        <div ref={setNodeRef}>
            {children}
        </div>
    );
}

const AssignTodoToKpi = (props) => {
    const {handleClose} = props;
    const [kpis, setKpis] = useState([]);
    const [todos, setTodos] = useState([]);
    const [toggle, setToggle] = useState({});
    const [activeId, setActiveId] = useState(null);
    const [draggingTodoId, setDraggingTodoId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);


    useEffect(() => {
        fetchKpis();
        fetchTodos();
    }, []);

    const fetchKpis = () => {
        getKpis().then((res) => {
            setKpis(res.data.main);
            handleToggle(res.data.main[0].id);
        })
    }

    const fetchTodos = (search = '') => {

        getAllTodos(search).then((res) => {
            setTodos(res.data.main);
        }).catch((error) => {
            toast.error(error.error);
        })
    }

    const updateKpis = (activeId, kpiId, criterionId, remove = false) => {
        let prevKpis = [...kpis];

        prevKpis.forEach((kpi) => {
            if (kpi.id == kpiId) {
                kpi.criteria.forEach((criterion) => {
                    if (criterion.id == criterionId) {
                        if (!remove) {
                            const todoExists = criterion.todos?.filter((todo) => todo.id == activeId);

                            if (!todoExists?.length) {
                                const todo = todos.find((todo) => todo.id == activeId);

                                criterion.todos.push(todo);
                            }
                        } else {
                            const filteredTodos = criterion.todos?.filter((todo) => todo.id != activeId);
                            criterion.todos = filteredTodos;
                        }
                    }
                })
            }
        });

        setKpis(prevKpis);
    }

    const handleToggle = (id) => {
        setToggle((prevToggle) => ({
            ...prevToggle,
            [id]: !prevToggle[id],
        }));
    };

    const handleDragEnd = (event) => {
        const {active, over} = event;
        const activeItemSplit = active.id.split('_');
        const overItemSplit = over.id.split('_');

        if (over && active.id !== over.id) {
            if (activeItemSplit[0] === 'todo') {
                //dragging is from todos to kpis.
                const activeId = activeItemSplit[1];
                const droppableItem = over.id.split('_');
                const kpiId = droppableItem[1];
                const criterionId = droppableItem[3];

                updateKpis(activeId, kpiId, criterionId);
            } else {
                //dragging from kpi list to todos
                if (!(activeItemSplit[0] === overItemSplit[0] && activeItemSplit[1] === overItemSplit[1] &&
                    activeItemSplit[2] === overItemSplit[2] && activeItemSplit[3] === overItemSplit[3])) {
                    const activeId = activeItemSplit[5];
                    const kpiId = activeItemSplit[1];
                    const criterionId = activeItemSplit[3];

                    updateKpis(activeId, kpiId, criterionId, true);
                }
            }
        }
    };

    const handleDragStart = (event) => {
        setActiveId(event.active.id);

        var todoId = event.active.id.split('_');
        todoId = todoId[todoId.length - 1];

        setDraggingTodoId(todoId);
    }

    const handleSaveClick = () => {
        setIsSubmitting(true);
        let postData = {"kpi_todo_items": []};

        kpis.forEach((kpi) => {
            let kpiTodoItem = {"kpi_id": kpi.id, "kpi_criteria": []};

            kpi.criteria?.forEach(criterion => {
                let kpiCriterion = {
                    "criteria_id": criterion.id,
                    "severity": criterion.severity,
                    "severity_color": criterion.severity_color,
                    "todo_ids": []
                };

                let criterionTodos = criterion.todos?.map(todo => todo.id);
                kpiCriterion.todo_ids = criterionTodos;

                kpiTodoItem.kpi_criteria.push(kpiCriterion);
            });

            postData.kpi_todo_items.push(kpiTodoItem);
        });

        assignTodosToKpis(postData).then(res => {
            if (res) {
                toast.success(res.message);

                if (handleClose) {
                    handleClose();
                }
            }

            setIsSubmitting(false);
        }).catch((error) => {
            toast.error(error.message);
            setIsSubmitting(false);
        });
    }

    return (
        <div>
            <DndContext collisionDetection={closestCenter} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                <Grid container spacing={2} sx={{marginTop: '0px'}}>
                    <Grid item xs={6}>
                        <Paper sx={{padding: '20px'}}>
                            <Box display='flex' justifyContent='space-between'>
                                <Typography
                                    variant='h5'
                                    component='h5'
                                    sx={{fontWeight: 'bold', textAlign: 'left', padding: '10px'}}>
                                    KPIs
                                </Typography>
                                <LoadingButton
                                    variant='contained'
                                    color='primary'
                                    type='submit'
                                    style={{
                                        margin: "10px",
                                    }}
                                    loading={isSubmitting}
                                    onClick={() => handleSaveClick()}
                                >
                                    Save
                                </LoadingButton>
                            </Box>

                            <div style={{maxHeight: "75vh", overflowY: 'auto'}}>
                                <List>
                                    {
                                        kpis.map((kpi) => (
                                            <Grid key={kpi.id} sx={{marginBottom: '10px'}}>
                                                <ListItem button onClick={() => handleToggle(kpi.id)}
                                                        sx={{
                                                            backgroundColor: '#F7F7F7',
                                                            color: '#000',

                                                            '&:hover': {
                                                                backgroundColor: '#F7F7F7',
                                                                color: '#000',
                                                                textDecoration: 'underline'
                                                            }
                                                        }}>
                                                    <ListItemText primary={kpi.title}/>
                                                    <IconButton size="small" sx={{color: "#000"}}>
                                                        {toggle[kpi.id] ? <ExpandLess/> : <ExpandMore/>}
                                                    </IconButton>
                                                </ListItem>
                                                <Collapse in={toggle[kpi.id]} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding sx={{
                                                        p: 2,
                                                        backgroundColor: '#F7F7F7',
                                                        borderTop: 'solid 1px rgba(0, 0, 0, 0.23)',
                                                        color: 'black',
                                                    }}>
                                                        {kpi.criteria.map((criterion) => (
                                                            <Grid sx={{
                                                                backgroundColor: '#fff',
                                                                padding: '10px',
                                                                marginBottom: '20px',
                                                                borderRadius: '10px'
                                                            }}>
                                                                <DroppableArea
                                                                    id={`kpi_${kpi.id}_criterion_${criterion.id}`}
                                                                    key="kpi-list">
                                                                    <ListItem button xs={2} sx={{
                                                                        borderBottom: 'solid 1px #f0f0f0',
                                                                        padding: '0 10px 6px',
                                                                        color: 'black',
                                                                        marginBottom: '10px',

                                                                        '&:hover': {
                                                                            backgroundColor: 'transparent',
                                                                        }
                                                                    }}>
                                                                        <ListItemText
                                                                            primary={criterion.title} primaryTypographyProps={{ sx: { fontWeight: 'bold' } }}/>

                                                                        <FormControl sx={{display: 'inline'}}>
                                                                            <Box display="flex" alignItems="left">
                                                                                <RadioGroup
                                                                                    row
                                                                                    size="small"
                                                                                    aria-labelledby='kpi-criteria-severity-radio-buttons-group-label'
                                                                                    name='severity'
                                                                                    value={criterion.severity}
                                                                                    onChange={(event) => {
                                                                                        const {value} = event.target;
                                                                                        const updatedKpis = kpis?.map((kpiItem) => {
                                                                                            return {
                                                                                                ...kpiItem,
                                                                                                criteria: kpiItem.criteria?.map(criterionItem => {
                                                                                                    if (criterionItem.id === criterion.id) {
                                                                                                        return {
                                                                                                            ...criterionItem,
                                                                                                            severity: value
                                                                                                        };
                                                                                                    }
                                                                                                    return criterionItem;
                                                                                                })
                                                                                            }
                                                                                        });

                                                                                        setKpis(updatedKpis);
                                                                                    }}
                                                                                >
                                                                                    {
                                                                                        kpi.criteria.map((criterionItem, itemIndex) => (
                                                                                            <FormControlLabel
                                                                                                value={itemIndex + 1}
                                                                                                control={
                                                                                                    <Radio
                                                                                                        sx={{
                                                                                                            padding: '0px',
                                                                                                            margin: '0px'
                                                                                                        }}
                                                                                                        icon={<span style={{
                                                                                                            borderRadius: '50%',
                                                                                                            backgroundColor: `${criterionItem.severity_color}`,
                                                                                                            width: 20,
                                                                                                            height: 20,
                                                                                                            padding: 0
                                                                                                        }}/>} // Custom unchecked icon
                                                                                                        checkedIcon={
                                                                                                            <span
                                                                                                                style={{
                                                                                                                    width: 20,
                                                                                                                    height: 20,
                                                                                                                    borderRadius: '50%',
                                                                                                                    display: 'flex',
                                                                                                                    alignItems: 'center',
                                                                                                                    justifyContent: 'center',
                                                                                                                    backgroundColor: `${criterionItem.severity_color}`,
                                                                                                                    color: 'black',
                                                                                                                }}
                                                                                                            >
                                                                                                                <Check
                                                                                                                    style={{fontSize: 16}}/>
                                                                                                            </span>
                                                                                                        }
                                                                                                    />
                                                                                                }/>
                                                                                        ))
                                                                                    }
                                                                                </RadioGroup>
                                                                            </Box>
                                                                        </FormControl>
                                                                    </ListItem>

                                                                    <List id={`kpi_criteria_${criterion.id}_todos`}
                                                                        component="div" disablePadding>
                                                                        {
                                                                            criterion.todos?.map((todo) => (
                                                                                <>
                                                                                    <DraggableItem
                                                                                        id={`kpi_${kpi.id}_criterion_${criterion.id}_todo_${todo.id}`}
                                                                                        key={`criterion_todo_${todo.id}`}
                                                                                    >
                                                                                        {(props) => (
                                                                                            <ListItem
                                                                                                button
                                                                                                ref={props.ref}
                                                                                                {...props.listeners}
                                                                                                {...props.attributes}
                                                                                                sx={{
                                                                                                    padding: '5px',
                                                                                                    mb: '5px',
                                                                                                    border: '1px solid #F0F0F0',
                                                                                                    borderRadius: '7px',
                                                                                                    backgroundColor: props.isDragging ? '#1565c0' : 'white',
                                                                                                    color: props.isDragging ? 'white' : 'black',
                                                                                                    boxShadow: props.isDragging ? '0 4px 10px rgba(0,0,0,0.3)' : 'none',
                                                                                                    transition: 'background-color 0.2s ease',
                                                                                                }}
                                                                                            >
                                                                                                <Tooltip
                                                                                                    title='Drag right to remove todo from kpi criteria'
                                                                                                    placement='top'>
                                                                                                    <DragIndicator/>
                                                                                                </Tooltip>

                                                                                                <ListItemText
                                                                                                    primary={todo.title}
                                                                                                    sx={{paddingLeft: '5px'}}/>
                                                                                            </ListItem>
                                                                                        )}
                                                                                    </DraggableItem>
                                                                                </>
                                                                            ))
                                                                        }
                                                                    </List>
                                                                </DroppableArea>
                                                            </Grid>

                                                        ))}
                                                    </List>
                                                </Collapse>
                                            </Grid>
                                        ))
                                    }
                                </List>
                            </div>

                        </Paper>
                    </Grid>

                    <Grid item xs={1} sx={{marginTop: '250px', textAlign: 'center'}}>
                        <SyncAlt sx={{fontWeight: 'bold', fontSize: '50px'}}/>
                    </Grid>

                    <Grid item xs={5}>
                        <Paper sx={{padding: '20px'}}>
                            <Box display='flex' justifyContent='space-between'>
                                <Typography
                                    variant='h5'
                                    component='h5'
                                    sx={{fontWeight: 'bold', textAlign: 'left', padding: '10px'}}>
                                    Todo's
                                </Typography>
                                <TextField
                                    name='search_todo'
                                    size='small'
                                    sx={{padding: 0}}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <Search/>
                                            </InputAdornment>
                                        )
                                    }}
                                    onInput={(event) => {
                                        let query = `?contains[title]=${event.target.value}`

                                        fetchTodos(query);
                                    }}/>
                            </Box>
                            <DroppableArea id="todo-list" key="todo-list">
                                <div style={{maxHeight: "75vh", overflowY: 'auto'}}>
                                    <List
                                        sx={{
                                            overflowY: 'auto',
                                        }}>
                                        {todos.map((todo) => (
                                            <DraggableItem id={`todo_${todo.id}`} key={`todo_${todo.id}`}>
                                                {(props) => (
                                                    <ListItem
                                                        button
                                                        ref={props.ref}
                                                        {...props.listeners}
                                                        {...props.attributes}
                                                        sx={{
                                                            padding: '5px',
                                                            mb: '5px',
                                                            border: '1px solid #F0F0F0',
                                                            borderRadius: '7px',
                                                            backgroundColor: props.isDragging ? '#1565c0' : 'white',
                                                            color: props.isDragging ? 'white' : 'black',
                                                            boxShadow: props.isDragging ? '0 4px 10px rgba(0,0,0,0.3)' : 'none',
                                                            transition: 'background-color 0.2s ease',
                                                        }}
                                                    >
                                                        <Tooltip title='Drag left to assign todo to kpi criteria' placement='top'>
                                                            <DragIndicator />
                                                        </Tooltip>
                                                        <ListItemText primary={todo.title} sx={{paddingLeft: '5px'}} />
                                                    </ListItem>
                                                )}
                                            </DraggableItem>
                                        ))}
                                    </List>
                                </div>

                            </DroppableArea>
                        </Paper>
                    </Grid>
                </Grid>
                <DragOverlay>
                    {activeId ? (
                        <Paper sx={{
                            padding: '8px',
                            mb: '5px',
                            border: '1px solid #F0F0F0',
                            borderRadius: '7px',
                            zIndex: 9999,
                            opacity: 0.8,
                        }}>
                            <div style={{display: 'flex', alignItems: 'left', alignContent: 'start'}}>
                                <DragIndicator style={{mb: 'auto'}}/>
                                <Typography xs={{alignText: 'left', justifyContent: 'left'}}>
                                    {todos.find((item) => item.id == draggingTodoId)?.title || ''}
                                </Typography>
                            </div>

                        </Paper>
                    ) : null}
                </DragOverlay>
            </DndContext>
        </div>
    );
}

export default AssignTodoToKpi;